/** Счётчики табов ЛК администратора (из макетов; «Услуги» пересчитывается из данных). */
export const ADMIN_CONSTRUCTOR_TAB_COUNTS = {
  roads: 16,
  documents: 6,
} as const;

/** Счётчики табов «Справочники» (из макета). */
export const ADMIN_REFERENCE_TAB_COUNTS = {
  documentTypes: 64,
  roles: 10,
  organizations: 8,
  workTypes: 12,
} as const;
